
import { Options, Vue } from "vue-class-component";
import { useRoute } from "vue-router";

@Options({
  props: {
    text: String,
  },
})
export default class TextField extends Vue {
  text!: string;
  route = useRoute();
}
